import { ref } from 'vue'
import store from '@/store'
import redeMarketingApi from '@/services/api/redeMarketingRepository'

/**
 * Composable que garante que o treinador esta autenticado na API do rede_marketing
 * e retorna o membroId / codigoIndicacao dele.
 *
 * Fluxo:
 *   1. Se ja tem redeMarketingJwt + membroId no store, retorna direto.
 *   2. Senao, chama POST /api/auth/login com o token Sanctum.
 *   3. O backend responde com { token, membroId, codigoIndicacao } - salva no store.
 *   4. Se membroId vier null, significa que o coach ainda nao foi sincronizado;
 *      o consumidor deve mostrar mensagem instrutiva.
 *
 * Retorna reativas: loading, erro, membroId, codigoIndicacao, naoSincronizado.
 */
export function useMembroLogado() {
  const loading = ref(true)
  const erro = ref(null)
  const membroId = ref(null)
  const codigoIndicacao = ref(null)
  const naoSincronizado = ref(false)

  async function garantir() {
    loading.value = true
    erro.value = null

    try {
      const existingJwt = store.getters.RedeMarketingJwt
      const existingMembroId = store.getters.RedeMarketingMembroId
      const existingCodigo = store.getters.RedeMarketingCodigoIndicacao

      if (existingJwt && existingMembroId) {
        membroId.value = existingMembroId
        codigoIndicacao.value = existingCodigo
        return
      }

      const sanctumToken = store.getters.ApiToken
      if (!sanctumToken) {
        throw new Error('Usuario nao autenticado no Diario de Treino')
      }

      const resp = await redeMarketingApi.Login(sanctumToken)
      const data = resp.data
      store.commit('SET_REDE_MARKETING_AUTH', {
        jwt: data.token,
        membroId: data.membroId,
        codigoIndicacao: data.codigoIndicacao,
      })

      membroId.value = data.membroId
      codigoIndicacao.value = data.codigoIndicacao

      if (!data.membroId) {
        naoSincronizado.value = true
      }
    } catch (e) {
      console.error('[useMembroLogado]', e)
      erro.value = e.response?.data?.message || e.message
    } finally {
      loading.value = false
    }
  }

  return { loading, erro, membroId, codigoIndicacao, naoSincronizado, garantir }
}
